import { Id } from 'app/shared/domain/value-objects/id';

export class WarehouseContactCode extends Id {

}
